export enum TtsOutputFormatType {
  MP3 = 'mp3',
  PCM = 'pcm'
}
